import React from 'react';
import PropTypes from 'prop-types';
import * as Styled from './FormLabel.styled';
import { useFormControl } from '../FormControl/FormControl.context';

/**
 * `FormLabel` is used to display a label for a `FormInput`.
 * It uses state from `FormControl`.
 */
const FormLabel = (props) => {
  const formContext = useFormControl();
  const { disabled } = props;

  return (
    <>
      <Styled.Backdrop
        isFocused={formContext.isFocused}
        hasError={!!formContext.errorMessage}
        disabled={disabled}
      />
      <Styled.Label
        {...props}
        isFocused={formContext.isFocused}
        isEmpty={formContext.isEmpty}
      />
    </>
  );
};

FormLabel.propTypes = {
  disabled: PropTypes.bool
};

FormLabel.defaultProps = {
  disabled: false
};

export default FormLabel;
